import { DirectionEnum } from "@ryde/shared";

/**
 * Translation key of the tooltip on a calendar booking chip's direction icon.
 * RYDE-8171: a direction X booking is a meal-only booking (it used to fall through to "Direction B").
 */
export const getCalendarBookingDirectionTooltipKey = (
  direction: DirectionEnum | null | undefined,
): string => {
  if (direction === DirectionEnum.None) {
    return "selectListLabel.MealOnly";
  }

  if (direction === DirectionEnum.PickUp) {
    return "selectListLabel.DirectionA";
  }

  return "selectListLabel.DirectionB";
};
